// extracted by mini-css-extract-plugin
module.exports = {"layout":"NewSpecies_layout__2OPLv"};